/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Pages_Create_I_Frame_WidthInputs */

const en_forms_custom_pages_create_i_frame_width = /** @type {(inputs: Forms_Custom_Pages_Create_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iFrame Width`)
};

const de_forms_custom_pages_create_i_frame_width = /** @type {(inputs: Forms_Custom_Pages_Create_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iFrame-Breite`)
};

/**
* | output |
* | --- |
* | "iFrame Width" |
*
* @param {Forms_Custom_Pages_Create_I_Frame_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_pages_create_i_frame_width = /** @type {((inputs?: Forms_Custom_Pages_Create_I_Frame_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Pages_Create_I_Frame_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_pages_create_i_frame_width(inputs)
	return de_forms_custom_pages_create_i_frame_width(inputs)
});